import qs from 'query-string';

import { nextApiAuthServiceInstance } from '~/domains/services/nextApi.instance';

import type { APISection } from '../common/sections/types';
import type { APIField } from '../common/fields/types/main';
import type { QueryParams } from '../common/api/settings/types/query.params';

type SectionsResponse = {
  sections: APISection[];
};

export const getCreateNew = async (queryParams: QueryParams) => {
  const queryString = `?${qs.stringify(queryParams)}`;
  const response = await nextApiAuthServiceInstance.get<SectionsResponse>(
    `/contest/create/new${queryString}`
  );

  return response.data?.sections ?? [];
};

export const getCreateEndpointData = async <
  R extends APIField | APIField[] | APISection | APISection[],
>(
  endpoint: string,
  payload: Record<string, unknown>,
  method: 'GET' | 'POST' = 'GET',
  abortController?: AbortController,
  queryParams?: QueryParams
): Promise<R> => {
  const queryString = `?${qs.stringify(queryParams)}`;

  const response = await nextApiAuthServiceInstance.request<R>({
    url: `/contest/create/${endpoint}${queryString}`,
    signal: abortController?.signal,
    method,
    ...(method === 'GET'
      ? {
          params: payload,
        }
      : {
          data: payload,
        }),
  });

  return response.data;
};

export const postCreateContest = async (payload: Record<string, unknown>) => {
  const response = await nextApiAuthServiceInstance.post('/contest/create/new', payload);

  return response.data;
};
